import React from 'react'
import { makeStyles } from '@mui/styles'
import { useDispatch, useSelector } from 'react-redux'
import lang from '@/lang'
import TopPanel from '../top-panel/top-panel'
import { switchTenant } from '@/redux/ducks/user/info'
import logo from '@assets/images/logo/svg/logo-white.svg'

import { toast } from '@/modules/base/components/toast/toastConfig'
import { trackOmoSubscription } from '../../helpers/omoSubscriptionTracker'
import { useAppSelector } from '@/redux/store'

const DemoHeader = (props) => {
  const dispatch = useDispatch()
  const isDemo = useAppSelector(state => state.user.info?.activeTenant?.isDemo)
  const classes = useStyles(props)
  const { tenants } = useSelector(state => state.user.info)

  if (!isDemo) {
    return null
  }

  const closeDemoModus = () => {
    trackOmoSubscription(
      'click_demo-modus',
      'demo-modus_beenden',
    )

    const tenant = tenants.find(tenant => !tenant.isDemo)

    if (tenant) {
      dispatch(switchTenant(tenant, () => selectTenantDone(tenant)))
    }
  }

  const selectTenantDone = ({ tenantName, companyName }) => {
    const label = tenantName || companyName || lang.tenant.newTenant
    toast.showToast({ type: 'info', message: lang.tenant.tenantActivated(label) })
  }

  return (
    <>
      <TopPanel
        text={lang.demoHeaderText}
        buttonLabel={lang.demoHeaderButtonText}
        position='top'
        onClick={closeDemoModus}
        customClass={classes.topPanel}
        contentClass={classes.content}
        icon={logo}
      />
    </>
  )
}

const useStyles = makeStyles(theme => ({
  topPanel: {
    transform: 'unset',
  },
  content: {
    background: theme.isMeinbuero ? '#125899' : theme.navBackgroundColor,
    color: theme.isMeinbuero ? 'white' : '',
  },
  [theme.devices.mobile]: {
    topPanel: {
      width: '100%',
      transform: 'unset',
      left: 0,
    },
    content: {
      background: theme.mobileNav.demoHeader,
      alignItems: 'center',
    },
  },
  loader: {
    height: '100%',
    width: '100%',
    background: 'rgba(255, 255, 255, 0.8)',
  },
}))

export default DemoHeader
